module.exports = __webpack_public_path__ + "static/media/loader.b58f2a93.svg";